<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
         <div class="container">
           <div class="form-row">
             <div class="form-group col-md-4">
               <label>Fecha</label>

               <VueCtkDateTimePicker
                       v-model="fecha"
                       :locale="'es'"
                       :input-size="'sm'"
                       :format="'YYYY-MM-DD'"
                       :formatted="'YYYY-MM-DD'"
                       :range="false"
                       :auto-close="true"
                       :only-date="true"
                       :no-header="true"
               />
               <!--:no-header="true"-->

             </div>
             <div class="form-group col-md-5">
               <button class="btn btn-primary mt-4" v-on:click="loadItems">Ver</button>
               <button class="btn btn-primary mt-4 ml-1" v-on:click="onBtnExport">Descargar CSV</button>
             </div>

           </div>


           <div class="row">
             <ag-grid-vue
                     style="width: 100%; height: 400px"
                     class="ag-theme-alpine"
                     :columnDefs="columnDefs"
                     :rowData="rowData"
                     :gridOptions="gridOptions"
                     @grid-ready="onGridReady"

             >
             </ag-grid-vue>

           </div>

          </div>


        </div>



      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import {AgGridVue} from "ag-grid-vue";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Reportes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    'ag-grid-vue':AgGridVue
  },
  data() {
    return {
      title: "Reportes de temas",
      items: [
        {
          text: "Temas",

        }

      ],

      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      lista:[],
      fecha:null,
      fecha_mostrar:null,

      gridApi: null,
      columnApi: null,
      gridOptions: {

        //floatingFiltersHeight:50,
        defaultColDef: {
          sortable: true,resizable: true
        },
      },
    };
  },
  beforeMount() {

      this.columnDefs= [
        { headerName: "Escuela", field: "carrera", resizable: true ,width:"150px",filter: true,floatingFilter: true},
        { headerName: "Tipo", field: "tipo", resizable: true ,width:"110px",filter: 'agTextColumnFilter'},
        { headerName: "Nombres", field: "nombres" , resizable: true,width:"200px",filter: 'agTextColumnFilter',floatingFilter: true},
        { headerName: "Curso", field: "curso" , resizable: true,width:"200px",filter: 'agTextColumnFilter',floatingFilter: true},
        { headerName: "Grupo", field: "grupo_curso" , resizable: true,width:"150px"},
        { headerName: "Tema", field: "tema", resizable: true ,width:"150px",filter: 'agTextColumnFilter',floatingFilter: true},
        { headerName: "Hora inicio", field: "hora_inicio" ,width:"100px"},
        { headerName: "Hora final", field: "hora_final",width:"100px" },
        { headerName: "Aula virtual", field: "aula_virtual" ,editable: true,cellStyle: { 'background-color': '#F3F2A1'},resizable: true ,width:"250px"},
        { headerName: "Observacion", field: "observacion",resizable: true ,width:"200px" },

      ];
      this.rowData= [

      ];

  },
  methods: {
    onBtnExport() {
      this.gridApi.exportDataAsCsv();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      /*const allColumnIds = [];
      this.gridOptions.columnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      });

      this.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);*/
    },
    loadItems()
    {
      this.isLoading = true;
      this.axios.get(
      process.env.VUE_APP_BACKEND + "/api/reporte-temas",
          {
            params:
                    {
                      fecha:this.fecha,
                    }
          }
      )
      .then((response)=> {
        this.fecha_mostrar=this.fecha;
        this.lista=response.data;
        this.rowData=response.data;
        //this.gridOptions.api.sizeColumnsToFit();

      })
      .catch(() => {
        this.$swal("error", "Error", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    marcarAsistencia(){

    },
  },
  mounted() {
    var date= new Date();
    this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)

  }

}
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
